module.exports = __webpack_public_path__ + "static/media/clip.6e9030b8.svg";